import { createAsyncThunk } from '@reduxjs/toolkit';
import { Policy } from 'src/types/policyTypes';
import { DeletePolicyPayload, TogglePolicyStatusPayload } from '../../../types/policyEngineTypes';

export const deletePolicy = createAsyncThunk<
	{ policyId: string; policyName: string },
	DeletePolicyPayload,
	{ rejectValue: string }
>('policyEngine/deletePolicy', async ({ api, accountId, policyId, policyName }, { rejectWithValue }) => {
	try {
		await api.deletePolicyFeed(accountId, policyId);
		return { policyId, policyName };
	} catch (error) {
		console.error('Failed to delete policy:', error);
		return rejectWithValue(`Error on deleting ${policyName}! Please try again after some time.`);
	}
});

export const togglePolicyStatus = createAsyncThunk<
	Policy,
	TogglePolicyStatusPayload,
	{ rejectValue: string }
>('policyEngine/toggleStatus', async ({ api, accountId, policy, disabled }, { rejectWithValue }) => {
	try {
		const updatedPolicy = { ...policy, disabled };
		const response = await api.updatePolicyFeed(accountId, updatedPolicy, policy.id);
		return { ...updatedPolicy, ...response.data };
	} catch (error) {
		console.error('Failed to toggle policy status:', error);
		return rejectWithValue(`Error on updating ${policy.name}! Please try again after some time.`);
	}
});
